import { SessionDiscounts } from '../components/SessionDiscounts';
import { minValue, maxValue } from 'react-admin';
import Box from '@material-ui/core/Box';
import React, { useEffect, useRef, useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, SelectInput, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, NumberInput, BooleanInput, ResourceContextProvider, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, DateField, Filter, BooleanField, DateTimeInput, ReferenceInput, ReferenceField, useUpdate, useDataProvider, FunctionField, useCreate, RadioButtonGroupInput } from 'react-admin';import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconCancel from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EventIcon from '@material-ui/icons/Event';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import { Button as MuiButton } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CloseIcon from '@material-ui/icons/Close';
import { dateAndTimeToCatalan, subscriptionModule } from './../common/utils';  
import { modules } from './../common/constants';

import { EventsSessionsPricesList } from './../resources/events_sessions_prices';
import { EventsSessionsValidatorsList } from './../resources/events_sessions_validators';
import BulkDeleteButton from '../components/BulkDeleteButton';
import { TicketsMapSvgPreview } from '../components/TicketsMaps';

import { Link } from 'react-router-dom';
import { useForm, useFormState } from 'react-final-form';

import { validateMaxLength, validateInteger } from './../components/Validator';import { dateParser } from '../common/utils';

const getTotalCapacityLabel = (translate, isTicketingEvent) => isTicketingEvent
  ? translate('events_sessions.total_capacity')
  : subscriptionModule(modules.FACM)
    ? translate('events_sessions.total_assistants')
    : translate('events_sessions.total_capacity');

const shouldShowTotalCapacityInput = isTicketingEvent => subscriptionModule(modules.FACM) || isTicketingEvent;

const getTotalCapacityValue = record => record && record.total_capacity != null ? record.total_capacity : 0;
const sessionHasMap = record => record && record.maps_id != null;
const sameDateTime = (first, second) => {
  if (!first && !second) return true;
  if (!first || !second) return false;
  const firstTime = new Date(first).getTime();
  const secondTime = new Date(second).getTime();
  return !Number.isNaN(firstTime) && !Number.isNaN(secondTime) && firstTime === secondTime;
};

const finishAfterStart = startSource => (finish, values) => {
  if (!finish || !values || !values[startSource]) return undefined;
  const startTime = new Date(values[startSource]).getTime();
  const finishTime = new Date(finish).getTime();
  if (Number.isNaN(startTime) || Number.isNaN(finishTime)) return undefined;
  return finishTime > startTime ? undefined : 'common.validation.date_finish_after_start';
};

const validDate = value => {
  if (!value) return undefined;
  return Number.isNaN(new Date(value).getTime()) ? 'common.validation.invalid_date' : undefined;
};

const SessionMapField = ({ record }) => {
  const translate = useTranslate();

  if (!sessionHasMap(record)) {
    return translate('events_sessions.without_map');
  }

  return (
    <ReferenceField record={record} source="maps_id" reference="tickets_maps" link={false}>
      <TextField source="name" />
    </ReferenceField>
  );
};

const SessionTotalCapacityInput = ({ eventsId, gridSize = 12, ticketing }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [isTicketingEvent, setIsTicketingEvent] = useState(ticketing === true);

  useEffect(() => {
    if (typeof ticketing === 'boolean') {
      setIsTicketingEvent(ticketing === true);
      return;
    }

    if (!eventsId) return;

    let mounted = true;
    dataProvider.getOne('events', { id: eventsId })
      .then(({ data }) => {
        if (mounted) setIsTicketingEvent(data && data.ticketing === true);
      })
      .catch(() => {
        if (mounted) setIsTicketingEvent(false);
      });

    return () => {
      mounted = false;
    };
  }, [dataProvider, eventsId, ticketing]);

  if (!shouldShowTotalCapacityInput(isTicketingEvent)) return null;

  return (
    <Grid item xs={12} sm={gridSize}>
      <NumberInput fullWidth source="total_capacity" label={getTotalCapacityLabel(translate, isTicketingEvent)} defaultValue={0} />
    </Grid>
  );
};

export const EventsSessionsList = (props) => {
  const translate = useTranslate();  
  const totalCapacityLabel = getTotalCapacityLabel(translate, props.ticketing === true);
  const showSessionCapacity = subscriptionModule(modules.FACM);
    
  let basePath='/events_sessions'; 
  let resource = 'events_sessions';

  if (!props.ticketing) {
    return (
      <ResourceContextProvider value={resource}>
        <List 
          basePath={basePath}   
          filter={{ events_id: props.events_id }}  
          actions={props.show ? <span/> : <EventsSessionsListActions events_id={props.events_id} ticketing={props.ticketing === true} />}    
          empty={props.show ? <span/> : <EventsSessionsListActions events_id={props.events_id} ticketing={props.ticketing === true} />}        
          bulkActionButtons={!props.show ? <BulkDeleteButton
            resource_name="events_sessions"
            confirmTitle={translate('events_sessions.delete_all_confirm_title')}
            confirmDescription={translate('events_sessions.delete_all_confirm_description')}
            confirmAsk={translate('events_sessions.delete_all_confirm_ask')}
            minRemaining={1}
            minRemainingError={translate('events_sessions.delete_all_min_remaining_error')}
          /> : false}
          perPage={1000}   
          pagination={false}
          sort={{ field: 'dateStart', order: 'ASC' }} 
          label=""  
          title=""  
          resource={resource}
        >        
        <Datagrid rowClick={null}>  
            <DateField source="date_start" label={translate('events_sessions.date_start')} sortable={false} options={dateTimeFormat} />
            <DateField source="date_finish" label={translate('events_sessions.date_finish')} sortable={false} options={dateTimeFormat} />
            <FunctionField source="maps_id" label={translate('events_sessions.map')} sortable={false} render={record => <SessionMapField record={record} />} />
            <FunctionField source="maps_id" label={translate('tickets_maps.preview')} sortable={false} render={record => record.maps_id ? <TicketsMapSvgPreview mapId={record.maps_id} sessionId={record.id} title={record.name} editable /> : null} />
            {showSessionCapacity ? <FunctionField source="total_capacity" label={totalCapacityLabel} sortable={false} render={record => sessionHasMap(record) ? '' : getTotalCapacityValue(record)} /> : null}
            {!props.show ? <EventsSessionsSimpleEditButton label="" ticketing={props.ticketing === true} /> : null}
            {!props.show ? <EventsSessionsDuplicateButton label=""/> : null}
            {!props.show ? <DeleteButton undoable={false} redirect={`/events/${props.events_id}/sessions`} label="" title={translate('ra.action.delete')} aria-label={translate('ra.action.delete')} /> : null}
          </Datagrid>        
        </List>
      </ResourceContextProvider>
    );
  }
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ events_id: props.events_id }}  
        actions={props.show ? <span/> : <EventsSessionsListActions events_id={props.events_id} ticketing={props.ticketing === true} />}    
        empty={props.show ? <span/> : <EventsSessionsListActions events_id={props.events_id} ticketing={props.ticketing === true} />}        
        bulkActionButtons={!props.show ? <BulkDeleteButton
          resource_name="events_sessions"
          confirmTitle={translate('events_sessions.delete_all_confirm_title')}
          confirmDescription={translate('events_sessions.delete_all_confirm_description')}
          confirmAsk={translate('events_sessions.delete_all_confirm_ask')}
          minRemaining={1}
          minRemainingError={translate('events_sessions.delete_all_min_remaining_error')}
        /> : false}
        perPage={1000}   
        pagination={false}
        sort={{ field: 'dateStart', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<EventsSessionsDetails ticketing={props.ticketing === true} />} >  
          <Avatar><EventIcon/></Avatar>     
          <DateField source="date_start" label={translate('events_sessions.date_start')} sortable={false} options={dateTimeFormat} />  
          <DateField source="date_finish" label={translate('events_sessions.date_finish')} sortable={false} options={dateTimeFormat} />  
          <FunctionField source="maps_id" label={translate('events_sessions.map')} sortable={false} render={record => <SessionMapField record={record} />} />
            <FunctionField source="maps_id" label={translate('tickets_maps.preview')} sortable={false} render={record => record.maps_id ? <TicketsMapSvgPreview mapId={record.maps_id} sessionId={record.id} title={record.name} editable /> : null} />
          {showSessionCapacity ? <FunctionField source="total_capacity" label={totalCapacityLabel} sortable={false} render={record => sessionHasMap(record) ? '' : getTotalCapacityValue(record)} /> : null}
          <BooleanField source="actived" label={translate('events_sessions.actived')} sortable={false} />         
          {!props.show ? <EventsSessionsDuplicateButton label=""/> : null}
          {!props.show ? <DeleteButton undoable={false} redirect={`/events/${props.events_id}/sessions`} label="" title={translate('ra.action.delete')} aria-label={translate('ra.action.delete')} /> : null}
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const EventsSessionsListActions = ({ events_id, ticketing }) => (
  <TopToolbar>
    <EventsSessionsCreateButton events_id={events_id} ticketing={ticketing} />
  </TopToolbar>
);

const EventsSessionsCreateButton = ({ events_id, ticketing }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('events_sessions');
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const translate = useTranslate();
  const handleSubmit = async values => {
    const sessionValues = {
      ...values,
      maps_id: ticketing && Number(values.has_seating_map) === 1 ? values.maps_id : null,
      default_price: ticketing ? values.default_price : 0
    };
    delete sessionValues.has_seating_map;

    create(
      { payload: { data: sessionValues } },
      {
        onSuccess: () => {
          setShowDialog(false);
          redirect('/events/' + events_id + '/sessions');
          refresh();
        },
        onFailure: error => {
          notify(error.message, 'error');
        }
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label={translate('events_sessions.create')} startIcon={<AddCircleOutlineIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('events_sessions.create')}
        className="dialog-md"
        maxWidth="sm"
      >
        <DialogTitle>{translate('events_sessions.create')}</DialogTitle>

        <FormWithRedirect
          resource="events_sessions"
          save={handleSubmit}
          initialValues={{ events_id, date_start: new Date(), has_seating_map: 0, default_price: 0 }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <DateTimeInput fullWidth source="date_start" label={translate('events_sessions.date_start')} validate={[required(), validDate]} parse={dateParser} />
                  </Grid>
                  {ticketing ?
                  <FormDataConsumer>
                    {({ formData, ...rest }) => (
                      <>
                        <Grid item xs={12}>
                          <RadioButtonGroupInput
                            source="has_seating_map"
                            label={translate('events.seating_map')}
                            choices={[
                              { id: 0, name: translate('common.no') },
                              { id: 1, name: translate('common.yes') }
                            ]}
                            defaultValue={0}
                            validate={[required()]}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <NumberInput fullWidth source="default_price" label={translate('events.default_price')} defaultValue={0} />
                        </Grid>
                        {Number(formData.has_seating_map) === 1 ?
                        <Grid item xs={12} sm={8}>
                          <ReferenceInput
                            fullWidth
                            label={translate('events_sessions.map')}
                            source="maps_id"
                            filter={{ associations_id: localStorage.getItem('associations_id') }}
                            reference="tickets_maps"
                            perPage={1000}
                            sort={{ field: 'id', order: 'ASC' }}
                          >
                            <SelectInput optionText="name" optionValue="id" validate={[required()]} />
                          </ReferenceInput>
                        </Grid>
                        : null}
                      </>
                    )}
                  </FormDataConsumer>
                  : null}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const dateTimeFormat = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
};

const EventsSessionsSimpleEditButton = ({ record, ...props }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [update, { loading }] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const showTotalCapacityInput = shouldShowTotalCapacityInput(props.ticketing === true) && !sessionHasMap(record);
  const dateGridSize = showTotalCapacityInput ? 4 : 6;

  const handleSubmit = async values => {
    update(
      {
        type: 'update',
        resource: 'events_sessions',
        payload: { id: values.id, data: values }
      },
      {
        onSuccess: () => {
          setShowDialog(false);
          refresh();
        },
        onFailure: error => {
          notify(error.message, 'error');
        }
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label="" startIcon={<EditIcon />} title={translate('common.edit')} aria-label={translate('common.edit')} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('common.edit')}
        className="dialog-md"
        maxWidth="sm"
      >
        <DialogTitle>{translate('common.edit')}</DialogTitle>

        <FormWithRedirect
          resource="events_sessions"
          save={handleSubmit}
          initialValues={showTotalCapacityInput ? { ...record, total_capacity: getTotalCapacityValue(record) } : record}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={dateGridSize}>
                    <DateTimeInput fullWidth source="date_start" label={translate('events_sessions.date_start')} validate={[required(), validDate]} parse={dateParser} />
                  </Grid>
                  <Grid item xs={12} sm={dateGridSize}>
                    <DateTimeInput fullWidth source="date_finish" label={translate('events_sessions.date_finish')} validate={[required(), validDate, finishAfterStart('date_start')]} parse={dateParser} />
                  </Grid>
                  <SessionTotalCapacityInput gridSize={4} ticketing={props.ticketing === true} />
                  <Grid item xs={12}>
                    <DateTimeInput fullWidth source="reservation_payment_period_finish" label={translate('events_sessions.reservation_payment_period_finish')} validate={[required(), validDate]} parse={dateParser} />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const EventsSessionsDuplicateButton = ({ record, ...props }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const translate = useTranslate();
  const defaultDuplicateDateStart = getNextDaySameTime(record.date_start);

  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowDialog(true);
  };

  const handleCancel = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowDialog(false);
  };

  const stopDialogPropagation = event => {
    event.stopPropagation();
  };

  const handleSubmit = async values => {
    const dates = values.dates ? values.dates.filter(item => item && item.date_start) : [];
    setLoading(true);
    try {
      await Promise.all(dates.map(item => dataProvider.create(`events_sessions/${record.id}/duplicate`, { data: { date_start: item.date_start } })));
      setShowDialog(false);
      redirect('/events/' + record.events_id + '/sessions');
      refresh();
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onMouseDown={event => event.stopPropagation()} onClick={handleClick} label="" startIcon={<FileCopyIcon />} title={translate('events_sessions.duplicate')} aria-label={translate('events_sessions.duplicate')} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('events_sessions.duplicate')}
        className="dialog-md"
        maxWidth="sm"
        onClick={stopDialogPropagation}
        onMouseDown={stopDialogPropagation}
      >
        <DialogTitle>{translate('events_sessions.duplicate')}</DialogTitle>

        <FormWithRedirect
          key={showDialog ? `duplicate-session-${record.id}` : 'duplicate-session-closed'}
          resource="events_sessions"
          save={handleSubmit}
          initialValues={{ dates: [{ date_start: defaultDuplicateDateStart }] }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent onClick={stopDialogPropagation} onMouseDown={stopDialogPropagation}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <DuplicateSessionDatesInput defaultDateStart={defaultDuplicateDateStart} />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onMouseDown={event => event.stopPropagation()} onClick={handleCancel} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const getNextDaySameTime = value => {
  if (!value) return value;
  const date = new Date(value);
  date.setDate(date.getDate() + 1);
  return date;
};

const cloneDateValue = value => value instanceof Date ? new Date(value.getTime()) : value;

const DuplicateSessionDatesInput = ({ defaultDateStart }) => {
  const form = useForm();
  const { values } = useFormState();
  const translate = useTranslate();
  const initialized = useRef(false);
  const dates = values && values.dates ? values.dates : [];

  useEffect(() => {
    if (!initialized.current && (!dates.length || !dates[0] || !dates[0].date_start) && defaultDateStart) {
      initialized.current = true;
      form.change('dates', [{ date_start: cloneDateValue(defaultDateStart) }]);
    }
  }, [dates, defaultDateStart, form]);

  const handleAddDate = event => {
    event.preventDefault();
    event.stopPropagation();

    const lastDate = dates.length && dates[dates.length - 1] && dates[dates.length - 1].date_start ? dates[dates.length - 1].date_start : defaultDateStart;
    const nextDate = getNextDaySameTime(lastDate);

    form.change('dates', [
      ...dates,
      { date_start: cloneDateValue(nextDate) }
    ]);
  };

  const handleRemoveDate = index => event => {
    event.preventDefault();
    event.stopPropagation();

    const nextDates = dates.filter((item, itemIndex) => itemIndex !== index);
    form.change('dates', nextDates.length ? nextDates : [{ date_start: cloneDateValue(defaultDateStart) }]);
  };

  const visibleDates = dates.length ? dates : [{ date_start: defaultDateStart }];

  return (
    <>
      {visibleDates.map((item, index) => (
        <Grid container spacing={1} alignItems="center" key={index}>
          <Grid item xs={10}>
            <DateTimeInput
              fullWidth
              source={`dates[${index}].date_start`}
              label={translate('events_sessions.date_start')}
              validate={[required()]}
              parse={dateParser}
            />
          </Grid>
          <Grid item xs={2}>
            <Button onMouseDown={event => event.stopPropagation()} onClick={handleRemoveDate(index)} label="" startIcon={<RemoveCircleOutlineIcon />} title={translate('ra.action.remove')} aria-label={translate('ra.action.remove')} disabled={dates.length <= 1} />
          </Grid>
        </Grid>
      ))}
      <Button onMouseDown={event => event.stopPropagation()} onClick={handleAddDate} label="ra.action.add" startIcon={<AddCircleOutlineIcon />} />
    </>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const EventsSessionsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
  const totalCapacityLabel = getTotalCapacityLabel(translate, props.ticketing === true);
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={12}>   
          <TextFieldShow source={record.name} label={translate('events_sessions.name')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.date_start)} label={translate('events_sessions.date_start')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.date_finish)} label={translate('events_sessions.date_finish')} />
        </Grid> 
        <Grid item xs={3}>
          <TextFieldShow source={dateAndTimeToCatalan(record.reservation_payment_period_finish)} label={translate('events_sessions.reservation_payment_period_finish')} />
        </Grid>
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.validators_start)} label={translate('events_sessions.validators_start')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.validators_finish)} label={translate('events_sessions.validators_finish')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.open_doors_start)} label={translate('events_sessions.open_doors_start')} />
        </Grid> 
        <Grid item xs={12} sm={4}>
          <TextFieldShow source={record.actived ? translate('common.yes') : translate('common.no')} label={translate('events_sessions.actived')} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldShow source={record.tickets_max_per_purchase} label={translate('tickets_general.tickets_max_per_purchase')} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldShow source={sessionHasMap(record) ? <SessionMapField record={record} /> : translate('events_sessions.without_map')} label={translate('events_sessions.map')} />
        </Grid>
        {!sessionHasMap(record) ? <Grid item xs={12} sm={4}>
          <TextFieldShow source={getTotalCapacityValue(record)} label={totalCapacityLabel} />
        </Grid> : null}
      </Grid>
      
    </div>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
  
  let linkBack = '';
  if (data && data.events_id)
      linkBack = '/events/' + data.events_id + '/sessions';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const EventsSessionsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));            
    redirect('/events/' + data.events_id + '/sessions');       
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={10}>   
                    <TextInput fullWidth source="name" label={translate('events_sessions.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={2}>   
                    <BooleanInput fullWidth source="actived" label={translate('events_sessions.actived')} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6">{translate('events_sessions.session_date_section')}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DateTimeInput fullWidth source="date_start" label={translate('events_sessions.date_start')} validate={[required(), validDate]} parse={dateParser} />
                  </Grid> 
                  <Grid item xs={12} sm={6}>
                    <DateTimeInput fullWidth source="date_finish" label={translate('events_sessions.date_finish')} validate={[required(), validDate, finishAfterStart('date_start')]} parse={dateParser} />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="h6">{translate('events_sessions.payment_period_section')}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <DateTimeInput fullWidth source="reservation_payment_period_finish" label={translate('events_sessions.reservation_payment_period_finish')} validate={[required(), validDate]} parse={dateParser} />
                  </Grid>

                  {!sessionHasMap(formData) ? <SessionTotalCapacityInput eventsId={formData.events_id} gridSize={6} /> : null}
                  <Grid item xs={12} sm={sessionHasMap(formData) ? 12 : 6}>
                    <ReferenceInput
                      fullWidth
                      label={translate('events_sessions.map')}
                      source="maps_id"
                      filter={{ associations_id: localStorage.getItem('associations_id') }}
                      reference="tickets_maps"
                      perPage={1000}
                      sort={{ field: 'id', order: 'ASC' }}
                    >
                      <SelectInput optionText="name" optionValue="id" resettable disabled />
                    </ReferenceInput>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="h6">{translate('events_sessions.access_section')}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <DateTimeInput fullWidth source="open_doors_start" label={translate('events_sessions.open_doors_start')} parse={dateParser} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <DateTimeInput fullWidth source="validators_start" label={translate('events_sessions.validators_start')} parse={dateParser} />
                  </Grid> 
                  <Grid item xs={12} sm={4}>
                    <DateTimeInput fullWidth source="validators_finish" label={translate('events_sessions.validators_finish')} parse={dateParser} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <NumberInput fullWidth source="tickets_max_per_purchase" label={translate('tickets_general.tickets_max_per_purchase')} step={1} validate={[required(), minValue(1), validateInteger(translate('common.validation.number'))]} />
                  </Grid>
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
        <FormTab
          label={translate('events_sessions.prices')}
          contentClassName={classes.tab}
          path="prices" 
                
        > 
               
          <EventsSessionsPricesList events_sessions_id={id} />
        </FormTab>         
        
        <FormTab label={translate('tickets_discounts.title')} contentClassName={classes.tab} path="discounts">
          <FormDataConsumer>
            {({ formData }) => <SessionDiscounts formData={formData} />}
          </FormDataConsumer>
        </FormTab>
        <FormTab label={translate('tickets_general.taxes')} contentClassName={classes.tab} path="taxes">
            <Box mt={3} mb={2} style={{ width: '100%' }}>
              <Typography variant="h6">{translate('tickets_general.taxes')}</Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <NumberInput fullWidth source="tickets_vat_percent" label={translate('tickets_general.vat_percent')} step={0.01} validate={[required(), minValue(0), maxValue(100)]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <BooleanInput fullWidth source="tickets_vat_included" label={translate('tickets_general.vat_included')} />
                </Grid>
              </Grid>
            </Box>
            <Box mt={3} mb={2} style={{ width: '100%' }}>
              <Typography variant="h6">{translate('tickets_general.management_fees')}</Typography>
              <BooleanInput fullWidth source="tickets_management_fees_included" label={translate('tickets_general.management_fees_included')} />
            </Box>
        </FormTab>
        <FormTab
          label={translate('events_sessions.validators')}
          contentClassName={classes.tab}
          path="validators" 
                
        > 
               
          <EventsSessionsValidatorsList events_sessions_id={id} />

        </FormTab>         
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

export const SessionPricePeriodsUpdateDialog = ({ open, value, onChange, onCancel, onSave }) => {
  const translate = useTranslate();
  const periodsStrategies = [
    {
      id: 'KEEP',
      label: translate('events_sessions.update_price_periods_keep'),
      description: translate('events_sessions.update_price_periods_keep_description'),
    },
    {
      id: 'SHIFT',
      label: translate('events_sessions.update_price_periods_shift'),
      description: translate('events_sessions.update_price_periods_shift_description'),
    },
    {
      id: 'GENERAL_DEFAULTS',
      label: translate('events_sessions.update_price_periods_defaults'),
      description: translate('events_sessions.update_price_periods_defaults_description'),
    },
  ];

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onCancel}
    >
      <DialogTitle disableTypography>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">{translate('events_sessions.update_price_periods_title')}</Typography>
          <IconButton aria-label="close" onClick={onCancel} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography>{translate('events_sessions.update_price_periods_description')}</Typography>
        <RadioGroup
          aria-label={translate('events_sessions.update_price_periods_title')}
          value={value}
          onChange={event => onChange(event.target.value)}
          style={{ marginTop: 12 }}
        >
          {periodsStrategies.map(strategy => (
            <FormControlLabel
              key={strategy.id}
              value={strategy.id}
              control={<Radio color="primary" />}
              label={(
                <div style={{ padding: '6px 0' }}>
                  <Typography variant="body1">{strategy.label}</Typography>
                  <Typography variant="body2" color="textSecondary">{strategy.description}</Typography>
                </div>
              )}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <MuiButton onClick={onCancel}>
          {translate('ra.action.cancel')}
        </MuiButton>
        <MuiButton color="primary" variant="contained" onClick={onSave}>
          {translate('ra.action.save')}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

const FormToolbar = ({ id , ...props }) => {
  const form = useForm();
  const { values, invalid } = useFormState({ subscription: { values: true, invalid: true } });
  const [periodsDialogOpen, setPeriodsDialogOpen] = useState(false);
  const [selectedPeriodsStrategy, setSelectedPeriodsStrategy] = useState('SHIFT');
  const pendingRedirect = useRef();
  let redirect = '/events/' + props.record.events_id + '/sessions';  

  const sessionDatesChanged = !sameDateTime(props.record.date_start, values.date_start)
    || !sameDateTime(props.record.date_finish, values.date_finish);

  const handleSave = redirectTo => {
    if (invalid) {
      form.submit();
      return;
    }
    if (sessionDatesChanged) {
      pendingRedirect.current = redirectTo;
      setSelectedPeriodsStrategy('SHIFT');
      setPeriodsDialogOpen(true);
      return;
    }
    props.handleSubmitWithRedirect(redirectTo);
  };

  const closePeriodsDialog = () => {
    setPeriodsDialogOpen(false);
    pendingRedirect.current = undefined;
  };

  const saveWithStrategy = () => {
    if (form.getState().invalid) {
      closePeriodsDialog();
      form.submit();
      return;
    }
    form.change('price_periods_update_strategy', selectedPeriodsStrategy);
    setPeriodsDialogOpen(false);
    props.handleSubmitWithRedirect(pendingRedirect.current);
  };

  return (
    <>
      <Toolbar {...props} className="user_form_toolbar" >
        <SaveButton handleSubmitWithRedirect={handleSave} />
        <DeleteButton redirect={redirect} mutationMode="pessimistic" />
      </Toolbar>
      <SessionPricePeriodsUpdateDialog
        open={periodsDialogOpen}
        value={selectedPeriodsStrategy}
        onChange={setSelectedPeriodsStrategy}
        onCancel={closePeriodsDialog}
        onSave={saveWithStrategy}
      />
    </>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const EventsSessionsCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('events_sessions.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
